import { ParentModel } from '@modules/parent/parent-model';

const fields = new ParentModel().fields();

export default [
  fields.id,

  fields.createdAt
];
